class Region {
  /**
   * @param {Object} data
   * @param {number} data.id
   * @param {string} data.name
   * @param {string} data.clarifiedName
   * @param {Country} data.country
   */
  constructor({id, name, clarifiedName, country}) {
    /** @type {number} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.clarifiedName = clarifiedName;
    /** @type {Country} */
    this.country = country;
  }
}

export default Region;